// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6e3521e","952":"cf3349a3"}[chunkId] + ".chunk.js";
};